import { Link } from 'react-router-dom';
import { industries } from '../data/industries';
import { getCategory } from '../data/categories';
import { useReveal } from '../hooks/useReveal';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';
import Icon, { type IconName } from '../components/Icon';
import cncMachining from '../assets/images/cnc-machining.jpg';

export default function Industries() {
  useReveal('industries');

  return (
    <div>
      <PageHero
        eyebrow="Applications"
        title="Industries we serve"
        description="Daxesh chemistries solve real problems across the industries that keep the world moving — from precision machining to oilfield operations and high-speed textiles."
        image={cncMachining}
      />

      <section className="container-page py-16 sm:py-24">
        <div className="border-t border-ink/15">
          {industries.map((ind, i) => (
            <div
              key={ind.slug}
              className="reveal grid gap-6 border-b border-ink/15 py-10 lg:grid-cols-[auto_1fr_1.1fr] lg:items-start lg:gap-12"
              style={{ transitionDelay: `${(i % 3) * 60}ms` }}
            >
              <div className="flex items-center gap-4 lg:flex-col lg:items-start lg:gap-3">
                <span className="text-4xl font-normal text-secondary/60">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <Icon name={ind.icon as IconName} className="h-7 w-7 text-primary/70" />
              </div>
              <div>
                <h2 className="text-2xl font-semibold text-text-primary">{ind.name}</h2>
                <p className="mt-3 max-w-xl leading-7 text-text-secondary">{ind.description}</p>
                <div className="mt-5 flex flex-wrap gap-x-5 gap-y-2">
                  {ind.uses.map((u) => (
                    <span key={u} className="text-sm text-ink-soft">
                      {u}
                    </span>
                  ))}
                </div>
              </div>
              <div className="lg:pt-1">
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-secondary-dark">
                  Recommended products
                </p>
                <div className="mt-4 space-y-3">
                  {ind.categorySlugs.map((slug) => {
                    const cat = getCategory(slug);
                    if (!cat) return null;
                    return (
                      <Link
                        key={slug}
                        to={`/products/${slug}`}
                        className="group flex items-center gap-2 text-lg font-medium text-primary hover:text-primary-dark"
                      >
                        {cat.name}
                        <Icon
                          name="arrow"
                          className="h-4 w-4 transition-transform group-hover:translate-x-1"
                        />
                      </Link>
                    );
                  })}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <CTASection />
    </div>
  );
}
